import * as React from "react";
import { IRadioOption, RadioList } from "../../Common/radio-list";
import { StateSelectList } from "../../Common/SelectLists";

export const searchIsNotEmpty = (params: LocationSearchParams) => {
  return (
    params.CitySearchTerm !== "" ||
    params.NameSearchTerm !== "" ||
    params.StateSearchTerm !== ""
  );
};

// the search form for searching for locations.
export const LocationSearchForm: React.FunctionComponent<{
  params: LocationSearchParams;
  onSearchChange: (params: LocationSearchParams) => void;
}> = (props: {
  params: LocationSearchParams;
  onSearchChange: (params: LocationSearchParams) => void;
}) => {
  const [params, setParams] = React.useState<LocationSearchParams>(
    props.params
  );

  const handleIntChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
  ) => {
    const value = parseInt(e.target.value, 10);

    const newParams = {
      ...params,
      [e.target.name]: value,
    };

    setParams(newParams);
    props.onSearchChange(newParams);
  };
  const handleChange = (
    e:
      | React.ChangeEvent<HTMLInputElement>
      | React.ChangeEvent<HTMLSelectElement>
  ) => {
    const value = e.target.value;

    const newParams = {
      ...params,
      [e.target.name]: value,
    };

    setParams(newParams);
    props.onSearchChange(newParams);
  };

  const key = Math.floor(Math.random() * 10000);

  const locationTypes: Array<IRadioOption> = [
    {
      key: "rdoHospitalType_" + key,
      value: 0,
      name: "Hospitals",
      isChecked: params.FacilityType === 0,
    },
    {
      key: "rdoHospitalType_" + (key + 1),
      value: 1,
      name: "Nursing Homes",
      isChecked: params.FacilityType === 1,
    },
  ];
  const groupName = "FacilityType";

  return (
    <div className="location-search">
      <h1>Search for a Hospital:</h1>

      <div className="row">
        <div className="col-sm-12">
          <div className="form-group">
            <label htmlFor="StateSearchTerm">State / Province</label>
            <StateSelectList
              name="StateSearchTerm"
              onChange={handleChange}
              value={params.StateSearchTerm}
            />
          </div>
        </div>
      </div>

      <fieldset className="search-group">
        <legend>Find by City OR Keyword</legend>
        <div className="row">
          <div className="col-sm-12">
            <div className="form-group">
              <label htmlFor="CitySearchTerm">City:</label>
              <input
                name="CitySearchTerm"
                id="CitySearchTerm"
                onChange={handleChange}
                className="form-control"
                value={params.CitySearchTerm}
              />
            </div>
          </div>
          <div className="col-sm-12">
            <div className="form-group">
              <label htmlFor="NameSearchTerm">Keyword:</label>
              <input
                name="NameSearchTerm"
                id="NameSearchTerm"
                onChange={handleChange}
                className="form-control"
                value={params.NameSearchTerm}
                placeholder="e.g. St. Joseph, Children's, or Memorial"
              />
            </div>
          </div>
        </div>
        {params.CitySearchTerm && params.NameSearchTerm && (
          <p className="search-group-note">Keyword is being used — city will be ignored</p>
        )}
      </fieldset>

      <div className="form-group">
        <fieldset className="radioButtons">
          <legend>Select Facility Type:</legend>

          <RadioList
            handleChange={handleIntChange}
            radioOptions={locationTypes}
            name={groupName}
          />
        </fieldset>
      </div>

      <p>
        * Please Note: Hospitalgiftshop.com delivers flowers to all hospitals
        listed. Not all hospitals are directly affiliated with
        hospitalgiftshop.com.
      </p>
    </div>
  );
};
